import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Trans } from '@common/i18n/trans';
import { Button } from '@common/ui/buttons/button';
import { AddIcon } from '@common/icons/material/Add';
import { List, ListItem } from '@common/ui/list/list';
import { LoanProgramItem } from './loan-program-item';
import { ParentRowLoanProgram } from './loan-program-parent';
import { FileItem } from './file-item';
import { RowLoanProgram } from './loan-program-row';


export interface LoanProgramPayload {
  items: Array<any>;
  key: string;
}

export function CrupdateLoanProgramForm({
  loan_product,
  loan_program_items,
}: {
  loan_product: any;
  loan_program_items?: any;
}) {
  // const form = useFormContext<LoanProgramPayload>();
  const [items, setItems] = useState<LoanProgramItem[]>(loan_program_items.length ? loan_program_items : [{ key: "1" }]);
  const len = loan_program_items ? loan_program_items.length : 1;
  const [cnt, setCnt] = useState(len);
  const [last, setLast] = useState(len);

  useEffect(() => {
    setItems(items);
    setLast(last + 1);
  }, [cnt]);

  const [subItems, setSubItems] = useState([]);
  
  const removeParent = (canRemove: boolean, pidx: number) => {
    if (canRemove) {
      items.splice(pidx, 1);
      setCnt(cnt - 1);
    }
  };

  useEffect(() => {
    setItems(loan_program_items);
  }, [loan_program_items]);

  useEffect(() => {
    setItems(items);
  }, [subItems]);

  useEffect(() => {
    setSubItems(subItems);
    setLast(last + 1);
  }, [cnt]);

  useEffect(() => {
    if (subItems) {
      setSubItems(subItems);
    }
  }, [subItems]);

  const [metaHeader, setMetaHeader] = useState('');
  const changeMetaHeader = (metaHeader: string) => {
    setMetaHeader(metaHeader);
  };

  const [uploadedFileItem, setUploadedFileItem] = useState<FileItem>();
  const uploadFileItem = (fileItems: any) => {
    setUploadedFileItem(fileItems);
  };

  return (
    <Fragment>
      <div className="gap-10">
        <div className="flex">
          <div className="w-[10%] p-10">
            <Button
              startIcon={<AddIcon />}
              variant="flat"
              color="primary"
              onClick={() => {
                items.push({ key: last.toString(), subItems: [{ key: "1", meta_header: "", }] });
                setCnt(cnt + 1);
              }}
            >
              <Trans message="Add Loan Program" />
            </Button>
          </div>
        </div>

        <aside className="sticky top-10 w-[100%] flex">
          <List padding="p-0" className="scroll-p-8 overflow-y-scroll min-h-600 w-[900%]">
            {items?.map((item: any, pidx: number) => (
              <ListItem className="border-b-1" key={`meta-${item.id ?? pidx}`}>
                <>
                  <ParentRowLoanProgram
                    key={`fist-row-${item.id ?? pidx}`}
                    id={item?.id}
                    loan_product={loan_product}
                    pidx={item.id ?? pidx}
                    removeParent={removeParent}
                    changeMetaHeader={changeMetaHeader}
                    uploadedFileItem={uploadedFileItem??item.files}
                  />
                  
                  <RowLoanProgram
                    subItems={subItems}
                    key={`row-${item.id ?? pidx}`}
                    id={item?.id}
                    loan_product={loan_product}
                    meta_hader={metaHeader ? metaHeader : item.meta_hader}
                    item={item}
                    pidx={item.id ?? pidx}
                    uploadFileItem={uploadFileItem}
                  />
                </>
              </ListItem>
            ))}
          </List>
        </aside>
      </div>
    </Fragment>
  );
}